export default {"src":"__ASTRO_ASSET_IMAGE__D4ZWsAv4__","width":37,"height":81,"format":"png"}